import { WithRouterProps } from 'next/dist/client/with-router'
import React from 'react'
import { GetUserDetails } from '../services/config'
import SchoolUserParentContainerComponent from '../containers/SchoolUser/SchoolUserParentContainerComponent'
import { ISchool } from '../interfaces/school.interface'
import { IUserDetails } from '../interfaces/user.interface'
import dynamic from 'next/dynamic'
import LoadingSkeletonComponent from '../components/LoadingComponents/LoadingSkeletonComponent'
import {
  GetAllClassInSchool,
  GetAllPaymentsPlanInSchool,
  GetCategoriesInSchool,
} from '../services/api-requests/api-request'
import { ICourse } from '../interfaces/ICourse'
import { ICategory } from '../interfaces/ICategory'
import { IPaymentsPlan } from '../interfaces/IPaymentsPlan'
import { useSchoolDetails } from '../hooks/useSchoolDetails'
import SchoolUserPageHead from '../components/SchoolUserPageHead'
import SchoolMaterialThemeContainer from '../containers/SchoolMaterialThemeContainer'
import ErrorComponent from './_error'
import { useRouter } from 'next/router'

interface IDiscussionProps extends WithRouterProps {
  classes: any // for material ui
  school_details: ISchool
  courses: ICourse[]
  categories: ICategory[]
  payment_plans: IPaymentsPlan[]
}

const DiscussionComponent = dynamic(
  () => import('../views/School/SchoolDiscussion'),
  {
    ssr: false,
    loading: () => (
      <div>
        <LoadingSkeletonComponent />
      </div>
    ),
  },
)

const DiscussionPage = (props: IDiscussionProps) => {
  const [userDetails, setUserDetails] = React.useState<
    IUserDetails | undefined
  >(undefined)

  const [onClient, setOnClient] = React.useState(false)

  React.useEffect(() => {
    if (onClient) {
      setOnClient(true)
      setUserDetails(GetUserDetails())
    } else {
      setOnClient(true)
    }
  }, [onClient])

  return (
    <div>
      <SchoolUserPageHead schoolDetails={props.school_details} />
      <SchoolMaterialThemeContainer schoolDetails={props.school_details}>
        <SchoolUserParentContainerComponent
          fb_pixel_id={props.school_details?.fb_pixels_id}
          school_id={props.school_details._id}
        >
          <DiscussionComponent
            schoolDetails={props.school_details}
            userDetails={userDetails}
            courses={props.courses}
            categories={props.categories}
            payment_plans={props.payment_plans}
          />
        </SchoolUserParentContainerComponent>
      </SchoolMaterialThemeContainer>
    </div>
  )
}

const DiscussionWrapper: React.FC<any> = ({ classes }: any) => {
  const router = useRouter()
  const {
    error: schoolError,
    schoolDetails,
  } = useSchoolDetails()
  const [courses, setCourses] = React.useState<any[]>([])
  const [categories, setCategories] = React.useState<any[]>([])
  const [paymentPlans, setPaymentPlans] = React.useState<any[]>([])

  React.useEffect(() => {
    if (!schoolDetails?._id) {
      return
    }

    let active = true
    const fetch = async () => {
      try {
        const [coursesRes, categoriesRes, paymentRes] = await Promise.all([
          GetAllClassInSchool(schoolDetails._id),
          GetCategoriesInSchool(schoolDetails._id),
          GetAllPaymentsPlanInSchool(schoolDetails._id),
        ])
        if (!active) return
        setCourses(coursesRes?.data?.data || [])
        setCategories(categoriesRes?.data?.data || [])
        setPaymentPlans(paymentRes?.data?.data || [])
      } catch (err) {
        if (active) {
          console.error('Error fetching discussion page data', err)
        }
      }
    }
    fetch().catch(err => {
      console.error('Error fetching discussion page data', err)
    })
    return () => {
      active = false
    }
  }, [schoolDetails?._id])

  if (schoolError) {
    return <ErrorComponent statusCode={404} />
  }

  if (!schoolDetails) {
    return null
  }
  return (
    <DiscussionPage
      classes={classes}
      router={router}
      school_details={schoolDetails}
      courses={courses}
      categories={categories}
      payment_plans={paymentPlans}
    />
  )
}

export default DiscussionWrapper
